import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { combineLatest, EMPTY } from 'rxjs'
import { map, mergeMap, catchError } from 'rxjs/operators'
import { ParamsConfigModel } from '@appService/stores/params-config/params-config.model'
import { AppConfigService } from '@app/service/admin/app-config.service'
import { environment } from '@appEnv/environment'
const listPullDefault = ['']
@Injectable()
export class ParamsConfigEffects {

  // pullParams$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType('[ParamsConfig] Pull'),
  //     mergeMap(() => combineLatest(
  //       ...listPullDefault.map(name => this.getConfigs(name))
  //     ).pipe(
  //       map((resp) => {
  //         const payload: ParamsConfigModel = {}
  //         listPullDefault.forEach(
  //           (name, key) => payload[name] = resp[key]
  //         )
  //         return { type: '[ParamsConfig] Replace', payload: payload }
  //       }),
  //       catchError(() => EMPTY)
  //     )
  //     )
  //   )
  // )

  // pullParamsByName$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType('[ParamsConfig] Pull By Name'),
  //     mergeMap(({ name }) => {
  //       return this.getConfigs(name).pipe(
  //         map(res => {
  //           const data: any = {}
  //           data[name] = res
  //           return { type: '[ParamsConfig] Replace', payload: name }
  //         }),
  //         catchError(() => EMPTY)
  //       )
  //     }
  //     )
  //   )
  // )

  constructor(
    private actions$: Actions,
    // private appConfigService: AppConfigService
  ) {
  }

  // getConfigs(name: string) {
  //   return this.appConfigService.getConfigByGroupCode(name, environment?.applicationCode || 'SMOS').pipe(
  //     map(resp => (resp?.data?.content || resp?.data)?.map((x: any) => ({
  //       ...x,
  //       value: x.value,
  //       label: x.description
  //     })) || [])
  //   )
  // }
}
